import { Separator } from "@/components/ui/separator"
import { SidebarTrigger } from "@/components/ui/sidebar"

interface SiteHeaderProps {
  title?: string;
  tracksCount?: number;
}

export function SiteHeader({ title = "Music", tracksCount }: SiteHeaderProps = {}) {

  return (
    <header className="group-has-data-[collapsible=icon]/sidebar-wrapper:h-12 flex h-12 shrink-0 items-center gap-2 border-b transition-[width,height] ease-linear z-20 relative">
      <div className="flex w-full items-center gap-1 px-4 lg:gap-2 lg:px-6">
        <SidebarTrigger className="-ml-1" />
        <Separator
          orientation="vertical"
          className="mx-2 data-[orientation=vertical]:h-4"
        />
        <h1 className="text-base font-medium">{title}</h1>
        {tracksCount !== undefined && (
          <span className="text-sm text-muted-foreground">
            {tracksCount} track{tracksCount !== 1 ? 's' : ''}
          </span>
        )}
      </div>
    </header>
  )
}
